import { AsyncCallResponse } from '../http';

export type DownloadResponse = AsyncCallResponse<Blob>;
